<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="400"
    @click:outside="closeForm()"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-if="id" icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      
      <v-btn v-else 
        fab 
        dark 
        small 
        color="primary"
        v-on="on"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-7">
        <v-form ref="form" v-model="isValidForm">
           <v-text-field
            label="Название этапа *"
            v-model="name"
            filled
            :rules="[v => !!v || 'Введите название этапа']"
           ></v-text-field>
        </v-form>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save()"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'stage-card',

  props: {
    id: String
  },

  data() {
    return {
      activeMode: false,
      isValidForm: false,
      title: this.id ? 'Редактирование этапа работ' : 'Создание этапа работ',
      name: this.id ? this.$store.getters['prices/getStageById'](this.id).name : ''
    }
  },

  methods: {
    save() {
      this.$refs.form.validate();
      if (this.isValidForm) {
        if (this.id) this.$store.commit('prices/SET_STAGE_NAME', { id: this.id, name: this.name})
        else this.$store.commit('prices/CREATE_STAGE', this.name);
        this.closeForm();
      }
    },

    closeForm() {
      this.activeMode = false;
      this.$refs.form.resetValidation();
      this.name = this.id ? this.$store.getters['prices/getStageById'](this.id).name : '';
    }
  }
}
</script>